module.exports = __webpack_public_path__ + "img/makenai.cc91ba65.png";